import React from 'react';
import styles from '../style/HomePage.module.css';

function TermsPage() {
  return (
    <div className={styles.pageContainer} style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', color: 'var(--text-primary)' }}>
      <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>
      <p>Stand: {new Date().toLocaleDateString('de-DE')}</p>

      <section style={{ marginTop: '2rem' }}>
        <h2>1. Geltungsbereich</h2>
        <p>
          Für die Geschäftsbeziehung zwischen der AWN GmbH (nachfolgend „Anbieter“) und dem Kunden (nachfolgend „Kunde“) 
          gelten ausschließlich die nachfolgenden Allgemeinen Geschäftsbedingungen in ihrer zum Zeitpunkt der Bestellung gültigen Fassung.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>2. Vertragsgegenstand</h2>
        <p>
          Der Anbieter stellt dem Kunden Software-Lösungen (SaaS) im Bereich KI und Anomalie-Erkennung zur Verfügung. 
          Der genaue Leistungsumfang ergibt sich aus der jeweiligen Produktbeschreibung im Dashboard.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>3. Vertragsschluss</h2>
        <p>
          Der Vertrag kommt durch die Registrierung auf der Website und, im Falle kostenpflichtiger Leistungen, 
          durch den Abschluss des Bezahlvorgangs via Stripe zustande.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>4. Laufzeit und Kündigung</h2>
        <p>
          Abonnements werden auf unbestimmte Zeit geschlossen. Die Kündigungsfristen und Laufzeiten richten sich nach dem 
          gewählten Preismodell (siehe Preisseite). Die Kündigung kann jederzeit über die Profileinstellungen erfolgen.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>5. Haftung</h2>
        <p>
          Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit. Für leichte Fahrlässigkeit haftet der Anbieter nur 
          bei Verletzung wesentlicher Vertragspflichten.
        </p>
      </section>

      <section style={{ marginTop: '2rem' }}>
        <h2>6. Schlussbestimmungen</h2>
        <p>
          Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist der Sitz des Anbieters (Unterneukirchen), 
          sofern der Kunde Kaufmann ist.
        </p>
      </section>
    </div>
  );
}

export default TermsPage;